import React, {useState, useRef, useEffect} from 'react'
import Tooltip from '../Tooltip/Tooltip'

const ListaDesplegableConTooltip = ({
  titulo,
  opciones = [],
  opcionesDeshabilitadas = [],
  valor,
  onChange,
  nombrePropiedadPorDefecto = 'Elegir',
  estilosContenedor = '',
  estilosLista = '',
}) => {
  const [abierto, setAbierto] = useState(false)
  const [hoveredTooltip, setHoveredTooltip] = useState(null)
  const contenedorRef = useRef()

  const todasLasOpciones = [
    ...opciones.map((op) => ({...op, disabled: false})),
    ...opcionesDeshabilitadas.map((op) => ({...op, disabled: true})),
  ]

  const opcionSeleccionada =
    todasLasOpciones.find((op) => op.Id === valor) || null

  const manejarSeleccion = (opcion) => {
    if (!opcion.disabled) {
      onChange && onChange({target: {value: opcion.Id}})
      setAbierto(false)
    }
  }

  const cerrarCuandoClickAfuera = (e) => {
    if (contenedorRef.current && !contenedorRef.current.contains(e.target)) {
      setAbierto(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', cerrarCuandoClickAfuera)
    return () => {
      document.removeEventListener('mousedown', cerrarCuandoClickAfuera)
    }
  }, [])

  return (
    <div
      ref={contenedorRef}
      className={`${estilosContenedor} relative inline-block w-72`}
    >
      <label className="block text-13px font-medium text-cendiatra mb-1">
        {titulo}
      </label>

      <div
        className={`border p-2 rounded-lg cursor-pointer uppercase bg-white ${
          !opcionSeleccionada?.Id
            ? 'text-cendiatra-gris-2'
            : 'text-cendiatra-gris-3'
        }  ${estilosLista} flex justify-between`}
        onClick={() => setAbierto((prev) => !prev)}
      >
        {opcionSeleccionada?.Nombre || nombrePropiedadPorDefecto}
        <span className="text-gray-500 ml-2">▼</span>
      </div>
      <div className="relative">
        {abierto && (
          <div className="absolute w-full uppercase">
            <ul
              className={`absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-md border ${estilosLista}`}
            >
              <li
                key="default-option"
                onClick={() => manejarSeleccion({Id: '', Nombre: ''})}
                className="px-4 py-2 text-sm text-cendiatra-gris-1 hover:bg-blue-100 cursor-pointer border-b border-cendiatra-gris-placeholder"
              >
                Elegir
              </li>
              {todasLasOpciones.map((opcion) => (
                <li
                  key={opcion.Id}
                  onClick={() => manejarSeleccion(opcion)}
                  onMouseEnter={() =>
                    opcion.disabled && setHoveredTooltip(true)
                  }
                  onMouseLeave={() =>
                    opcion.disabled && setHoveredTooltip(false)
                  }
                  className={`px-4 py-2 text-sm ${
                    opcion.disabled
                      ? ' cursor-not-allowed text-white bg-cendiatra-gris-2'
                      : 'hover:bg-blue-100 cursor-pointer text-cendiatra-gris-3 border-b border-cendiatra-gris-placeholder'
                  }`}
                >
                  {opcion.Nombre}
                </li>
              ))}
            </ul>

            {hoveredTooltip && (
              <div className="absolute mt-1 right-10 top-28">
                <Tooltip
                  tooltip={
                    'La empresa está inactiva. Comuníquese con su ejecutivo comercial al PBX: 601 744 3001'
                  }
                  activo={true}
                  estilosAdicionales={
                    'bg-cendiatra-verde-2 text-white normal-case'
                  }
                  width={300}
                ></Tooltip>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ListaDesplegableConTooltip
